import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObjectIdLabelService } from './logic/object-id-label.service';
import { ObjectIdLabelLogicService } from './logic/object-id-label/object-id-label-logic.service';
import { ObjectIdLabelDaoService } from './dao/object-id-label-dao.service';
import { ObjectIdLabelStorageDaoService } from './dao/object-id-label-dao/object-id-label-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: ObjectIdLabelService,
      useClass: ObjectIdLabelLogicService,
    },
    {
      provide: ObjectIdLabelDaoService,
      useClass: ObjectIdLabelStorageDaoService,
    },
  ],
})
export class ObjectIdLabelModule {}
